import { render, staticRenderFns } from "./FissionCreatePrizePane.vue?vue&type=template&id=0a79fe82&scoped=true"
import script from "./FissionCreatePrizePane.vue?vue&type=script&lang=js"
export * from "./FissionCreatePrizePane.vue?vue&type=script&lang=js"
import style0 from "./FissionCreatePrizePane.vue?vue&type=style&index=0&id=0a79fe82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79fe82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a79fe82')) {
      api.createRecord('0a79fe82', component.options)
    } else {
      api.reload('0a79fe82', component.options)
    }
    module.hot.accept("./FissionCreatePrizePane.vue?vue&type=template&id=0a79fe82&scoped=true", function () {
      api.rerender('0a79fe82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/fission/components/FissionCreatePrizePane.vue"
export default component.exports